export default "__VITE_ASSET__OT29nsP5__"